const pages = [
    5, 10, 20, 50, 100
];
export default pages;
